import { useEffect, useRef } from 'react';
import { apiHolder } from 'api';
import Alert from '@web-common/components/UI/Alert/Alert';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import { usePermissionCheck } from '@/components/UI/PrivilegeEnhance';
const useCommonErrorEvent = (name, callback, preHandler) => {
    const eventApi = apiHolder.api.getEventApi();
    const hasEdmPermission = usePermissionCheck('VIEW', 'EDM', 'EDM_SENDBOX');
    const hasEdmPermissionRef = useRef(false);
    useEffect(() => {
        hasEdmPermissionRef.current = hasEdmPermission;
    }, [hasEdmPermission]);
    useEffect(() => {
        const obFuc = (ev) => {
            if (ev && ev.eventData) {
                if (callback) {
                    callback(ev);
                }
                else {
                    const data = ev.eventData;
                    if (preHandler) {
                        const isComplete = preHandler(ev);
                        if (isComplete) {
                            return;
                        }
                    }
                    if (data.popupType && data.popupType === 'window') {
                        if (data.popupLevel && data.popupLevel in Alert) {
                            const params = {
                                content: data.title,
                                onOk: e => {
                                    if (data.confirmCallback && !(data.edmJump && !hasEdmPermissionRef.current)) {
                                        data.confirmCallback(e);
                                    }
                                    eventApi.confirmEvent(ev);
                                    al.destroy();
                                },
                                onCancel: e => {
                                    if (data.cancelCallback) {
                                        data.cancelCallback(e);
                                    }
                                    eventApi.confirmEvent(ev);
                                    al.destroy();
                                },
                            };
                            if (data.title) {
                                params.content = data.title;
                            }
                            if (data.content) {
                                params.content = data.content;
                                params.title = data.title;
                            }
                            if (data.btnConfirmTxt) {
                                params.okText = data.btnConfirmTxt;
                            }
                            if (data.btnCancelTxt) {
                                params.cancelText = data.btnCancelTxt;
                            }
                            if (data.edmJump) {
                                params.edmJump = data.edmJump;
                                params.hasEdmPermission = hasEdmPermissionRef.current;
                            }
                            const al = Alert[data.popupLevel](params);
                        }
                    }
                    else if (data.popupType && data.popupType === 'toast') {
                        if (data.popupLevel && data.popupLevel in Toast) {
                            Toast[data.popupLevel]({
                                content: data.title,
                                duration: data.duration || 3,
                                onClose: () => {
                                    eventApi.confirmEvent(ev);
                                },
                            });
                        }
                    }
                }
            }
        };
        const id = eventApi.registerSysEventObserver('error', {
            name: name || 'commonErrorOb-' + (Date.now() % 1000000),
            func: obFuc,
        });
        return () => {
            if (id) {
                eventApi.unregisterSysEventObserver('error', id);
            }
        };
    }, []);
};
const useEventObserver = (eventId, obFunc) => {
    const eventApi = apiHolder.api.getEventApi();
    useEffect(() => {
        const id = eventApi.registerSysEventObserver(eventId, obFunc);
        return () => {
            eventApi.unregisterSysEventObserver(eventId, id);
        };
    }, []);
};
const useGlobalEventObserver = (eventId, func) => {
    const eventApi = apiHolder.api.getEventApi();
    useEffect(() => {
        const id = eventApi.registerSysEventObserver(eventId, { func });
        return () => {
            eventApi.unregisterSysEventObserver(eventId, id);
        };
    }, []);
};
export { useCommonErrorEvent, useEventObserver, useGlobalEventObserver };
